export { default as ScreenLocationDetail } from './detail'
export { default as ScreenLocationAdd } from './add'
export { default as ScreenLocationEdit } from './edit'
